export { BaseEntityAdapter } from "./base-entity-adapter";
export type {
  BaseEntityAdapterConfig,
  BaseEntityFrontmatterSchema,
  DefaultEntityFrontmatter,
} from "./base-entity-adapter";
export { FallbackEntityAdapter } from "./fallback-entity-adapter";
